import { Icon, Switch } from "@blueprintjs/core";
import * as React from "react";

export const AllUsersSwitch = ({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
}) => {
  return (
    <div
      style={{
        display: "flex",
        marginRight: "10px",
      }}
    >
      <Switch
        checked={value}
        name="personalSwitch"
        onChange={() => onChange(!value)}
        style={{ margin: 0 }}
      />
      <Icon icon={"people"} />
    </div>
  );
};
